import React, { useMemo } from 'react';

import type { Dayjs } from 'dayjs';

import dayjs from 'dayjs';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';
import { getDatesBetweenTwoDates } from 'utils/date';

import type { OrganizationJob } from 'state/remote/types';

import AsyncComponent from 'components/async-component';

import KanbanCard from '../kanban-card';

import KanbanColumnTitle from './kanban-column-title';
import PlannerTableSkeleton from './planner-table-skeleton';

const PlannerKanban: React.FC = () => {
  const { gridParams } = useOrganizationWeekPlanner();

  const { selectedWeek, jobs, isLoading } = gridParams;
  const days: Array<Dayjs> = useMemo(() => {
    return getDatesBetweenTwoDates(selectedWeek[0], selectedWeek[1]);
  }, [selectedWeek]);

  const groupedJobs: Array<{ id: string; jobs: Array<OrganizationJob> }> =
    useMemo(() => {
      return days.map((day) => {
        const filtredJobs = jobs.filter((job) =>
          dayjs(job.date).isSame(dayjs(day)),
        );
        return { id: day.toISOString(), jobs: filtredJobs };
      });
    }, [days, jobs]);

  return (
    <>
      {!isLoading && (
        <div className="grid grid-cols-1 lg:grid-cols-5 mb-4 w-full">
          {groupedJobs.map((collection, index) => (
            <div
              className="col-span-1 lg:border-r lg:min-h-[70vh]"
              key={days[index].toISOString()}
            >
              <KanbanColumnTitle title={days[index].format('dddd DD, MMMM')} />
              <div
                key={collection.id}
                className="flex flex-col lg:flex-row mt-4"
              >
                <div className="flex flex-col flex-1 p-3 lg:p-0 mb-4 lg:mb-auto lg:bg-inherit border-t border-gray100 lg:border-none">
                  {collection.jobs.map((job, jobIndex) => (
                    <AsyncComponent key={job.id} delay={jobIndex * 5}>
                      <KanbanCard job={job} className="mb-4" />
                    </AsyncComponent>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {isLoading && <PlannerTableSkeleton />}
    </>
  );
};
export default PlannerKanban;
